/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/bank'
export default icon
